import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "en",
  "use": "en-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"en\">\n  <defs>\n    <clipPath id=\"en_a\">\n      <path fill-opacity=\".7\" d=\"M250 0h500v500H250z\" />\n    </clipPath>\n  </defs>\n  <g clip-path=\"url(#en_a)\" transform=\"translate(-256) scale(1.024)\">\n    <g stroke-width=\"1pt\">\n      <path fill=\"#006\" d=\"M0 0h1000v500H0z\" />\n      <path fill=\"#fff\" d=\"M0 0v55.9L888.2 500H1000v-55.9L111.8.1H0zm1000 0v55.9L111.8 500H0v-55.9L888.2 0H1000z\" />\n      <path fill=\"#fff\" d=\"M416.7 0v500h166.6V0H416.7zM0 166.7v166.6h1000V166.7H0z\" />\n      <path fill=\"#c00\" d=\"M0 200v100h1000V200H0zM450 0v500h100V0H450zM0 500l333.3-166.7H408L74.5 500H0zM0 0l333.3 166.7h-74.5L0 37.3V0zm592.1 166.7L925.5 0h74.5L666.7 166.7H592zm408 333.3L666.6 333.3h74.5L1000 462.7V500z\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/en.svg
// module id = null
// module chunks = 